module.exports = __webpack_public_path__ + "img/Feature.051b1745.jpg";